// =========================================================
// Vojjin Toster Utilities
// =========================================================
import {registerGlobal} from "./core.js";

class Toster {
    constructor() {
        this.containers = {};
    }

    getContainer(position = "top-right") {
        if (!this.containers[position]) {
            const container = document.createElement("div");
            container.className = `tost-container ${position}`;
            document.body.appendChild(container);
            this.containers[position] = container;
        }
        return this.containers[position];
    }

    show({ message = "", type = "info", position = "top-right", duration = 4000 }) {
        const container = this.getContainer(position);

        // Create tost
        const tost = document.createElement("div");
        tost.className = `tost ${type}`;
        tost.innerHTML = `
      <div class="icon"></div>
      <div class="text">${message}</div>
    `;

        container.appendChild(tost);

        // Handle auto-remove
        let timeoutId;
        const remove = () => {
            tost.classList.add("hide");
            setTimeout(() => tost.remove(), 300);
        };

        const startTimer = () => {
            timeoutId = setTimeout(remove, duration);
        };
        const stopTimer = () => {
            clearTimeout(timeoutId);
            remove();
        }

        tost.addEventListener("mouseenter", stopTimer);
        tost.addEventListener("mouseleave", startTimer);
        tost.addEventListener("click", remove);

        startTimer();
    }
}


registerGlobal("Toster", Toster);
